import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from './../axiosInstance.js';
import { Title } from '@mantine/core';
import ArtForm, { defaultFormState } from './ArtForm';

const CreateArtProposal = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const [form, setForm] = useState(defaultFormState);
  const setField = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const payload = {
        ...form,
        category: parseInt(form.category, 10),
        year: form.year || 0,
        duration: form.duration || 0,
      };
      await axiosInstance.post('/artProposals', payload);
      setSuccess('Proposal created!');
      setTimeout(() => navigate('/artProposals'), 1000);
    } catch (err) {
      setError(err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-4">
      <Title order={2} mb="lg">Create Art Proposal</Title>
      <ArtForm
        form={form}
        setField={setField}
        onSubmit={handleSubmit}
        loading={loading}
        error={error}
        success={success}
        submitLabel="Submit Proposal"
      />
    </div>
  );
};

export default CreateArtProposal;
